import PageHeader from "@/components/site/PageHeader";
import ContactForm from "@/components/sections/ContactForm";
import { useI18n } from "@/i18n/i18n";

export default function Contact() {
  const { tr } = useI18n();
  return (
    <div data-testid="contact-page">
      <PageHeader
        overline={tr.contact_page.overline}
        title={tr.contact_page.title}
        subtitle={tr.contact_page.subtitle}
      />
      <ContactForm />
    </div>
  );
}
